<template>
  <ModalBase
    :show-modal="true"
    @close-modal="close"
    :auto-h="true"
    class="new-promo-modal"
    :class="['new-promo-modal--' + theme]"
  >
    <template v-slot:maincontent>
      <div style="padding: 2rem; text-align: center" v-html="modalMessage" />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/base_components/ModalBase'
import TitleBar from '@/components/TitleBar'
import GekkoButton from '@/components/GekkoButton'
export default {
  name: 'PromoModalNew',
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
  },
  props: {
    theme: {
      type: String,
      default: 'base',
    },
    modalMessage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    document.body.classList.add('modal-on')
  },
  methods: {
    close() {
      console.log('close modal')
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.new-promo-modal {
  .gk-modal {
    padding: 0.5rem;
    max-width: 900px !important;
    .gk-modal-content {
      border-radius: $radiusMd;
      color: $colorTextBase;
      .modal-content-wrap {
        background: transparent;
      }
      .close-btn {
        top: 0;
        right: 0;
      }
    }
  }
  &--blackfriday {
    .gk-modal {
      .gk-modal-content {
        background: url('/static/images/bf2023-dash-banner-bg.png'),
          linear-gradient(103deg, rgb(234 23 50) 50%, rgb(94 18 24) 61%);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        color: white;
      }
    }
  }
}
</style>
